export var PlaylistRestartReason;
(function (PlaylistRestartReason) {
    PlaylistRestartReason[PlaylistRestartReason["RECEIVED_MISSING_SCREEN"] = 0] = "RECEIVED_MISSING_SCREEN";
    PlaylistRestartReason[PlaylistRestartReason["PLAYLIST_INDEX_MISMATCH"] = 1] = "PLAYLIST_INDEX_MISMATCH";
})(PlaylistRestartReason || (PlaylistRestartReason = {}));
var PlaylistSyncServiceBase = /** @class */ (function () {
    function PlaylistSyncServiceBase() {
    }
    return PlaylistSyncServiceBase;
}());
export { PlaylistSyncServiceBase };
